// Server-safe IconsGrid component
// This is a static version of common/IconGrids for server-side rendering

import ImageItem from "./ImageItem";
// import { Popup } from "./semantic-ui-react";
// import parse from "html-react-parser";

// const options = {
//   replace: (domNode) => {
//     if (domNode.attribs && domNode.attribs.class === "remove") {
//       return <></>;
//     }
//   },
// };

export default function IconsGrid({ gridData, onscoreclick, isMobile }) {
  return (
    <div className="grid_container">
      <ul className="nh_icon_grid_ul">
        {gridData &&
          gridData.map((grid, index) => (
            <li
              key={`${grid?.title}-icon-${index + 1}`}
              className={`${
                grid.isUndervalue && grid.isUndervalue != "-"
                  ? "valueditem"
                  : ""
              } grid_item`}
            >
              <ImageItem
                centered
                source={grid.HeaderImage}
                alt="Neighborhood Factors"
                title="Neighborhood Factors"
                height={isMobile ? "39.23" : "46.15"}
                width={isMobile ? 51 : 60}
              />
              {grid.title && (
                <div
                  className="ui small center aligned"
                  style={{
                    color: grid.txtColor,
                    fontSize: "13px",
                  }}
                >
                  {grid.title}
                </div>
              )}
              <div
                className="ui small center aligned header"
                style={{
                  color: "rgb(15, 20, 67)",
                  letterSpacing: "0.3px",
                  margin: "0px 7px",
                }}
              >
                {grid.link && grid.link !== "" && grid.link !== "safety" ? (
                  // Note: onClick is removed for server component - this is just a visual link
                  <a>{grid.SubContent}/5</a>
                ) : grid.isUndervalue &&
                  grid.isUndervalue != "-" &&
                  grid.isUndervalue !== "" ? (
                  <span
                    className={
                      grid.isUndervalue > 0 ? "overvalue_txt" : "undervalue_txt"
                    }
                  >
                    {grid.SubContent}
                  </span>
                ) : grid.tooltiptext ===
                  "Neighborhood weighted Appreciation" ? (
                  <span
                    className={
                      grid.SubContent > "0%"
                        ? "undervalue_txt"
                        : grid.SubContent != "-" && grid.SubContent != "0%"
                          ? "overvalue_txt"
                          : ""
                    }
                  >
                    {grid.SubContent != "-" ? grid.SubContent : "-"}
                  </span>
                ) : grid.link === "safety" ? (
                  grid.SubContent + "/5"
                ) : (
                  grid.SubContent
                )}
                {grid.appreciationCityFlag || grid.medianPriceDomCityFlag ? (
                  <sup style={{ left: "2px" }}>(2)</sup>
                ) : (
                  ""
                )}
                {grid.amenitiesFlag ? (
                  // Note: onClick is removed for server component
                  <sup style={{ left: "2px" }}>(1)</sup>
                ) : (
                  ""
                )}
              </div>
            </li>
            // <Popup
            //   key={index}
            //   className="right_content_top_popup"
            //   size="mini"
            //   on="hover"
            //   trigger={
            //     <li
            //       className={`${
            //         grid.isUndervalue && grid.isUndervalue != "-"
            //           ? "valueditem"
            //           : ""
            //       } grid_item`}
            //     >
            //       <ImageItem
            //         centered
            //         source={grid.HeaderImage}
            //         alt="Neighborhood Factors"
            //         title="Neighborhood Factors"
            //         height={isMobile ? "39.23" : "46.15"}
            //         width={isMobile ? 51 : 60}
            //       />
            //       {grid.title && (
            //         <div
            //           className="ui small center aligned"
            //           style={{
            //             color: grid.txtColor,
            //             fontSize: "13px",
            //           }}
            //         >
            //           {grid.title}
            //         </div>
            //       )}
            //       <div
            //         className="ui small center aligned header"
            //         style={{
            //           color: "rgb(15, 20, 67)",
            //           letterSpacing: "0.3px",
            //           margin: "0px 7px",
            //         }}
            //       >
            //         {grid.link && grid.link !== "" && grid.link !== "safety" ? (
            //           // Note: onClick is removed for server component - this is just a visual link
            //           <span style={{ cursor: "pointer", textDecoration: "underline" }}>
            //             {grid.SubContent}/5
            //           </span>
            //         ) : grid.isUndervalue &&
            //           grid.isUndervalue != "-" &&
            //           grid.isUndervalue !== "" ? (
            //           <span
            //             className={
            //               grid.isUndervalue > 0
            //                 ? "overvalue_txt"
            //                 : "undervalue_txt"
            //             }
            //           >
            //             {grid.SubContent}
            //           </span>
            //         ) : grid.tooltiptext ===
            //           "Neighborhood weighted Appreciation" ? (
            //           <span
            //             className={
            //               grid.SubContent > "0%"
            //                 ? "undervalue_txt"
            //                 : grid.SubContent != "-" &&
            //                   grid.SubContent != "0%" &&
            //                   "overvalue_txt"
            //             }
            //           >
            //             {grid.SubContent != "-" ? grid.SubContent : "-"}
            //           </span>
            //         ) : grid.link === "safety" ? (
            //           grid.SubContent + "/5"
            //         ) : (
            //           grid.SubContent
            //         )}
            //         {grid.appreciationCityFlag || grid.medianPriceDomCityFlag ? (
            //           <sup style={{ left: "2px" }}>(2)</sup>
            //         ) : (
            //           ""
            //         )}
            //         {grid.amenitiesFlag ? (
            //           // Note: onClick is removed for server component
            //           <sup style={{ left: "2px" }}>(1)</sup>
            //         ) : (
            //           ""
            //         )}
            //       </div>
            //     </li>
            //   }
            // >
            //   {parse(grid.tooltiptext, options)}
            // </Popup>
          ))}
      </ul>
    </div>
  );
}
